import React from 'react'
import './stylesheet/newuser.css'

export const NewUser = ({ newUser }) => {
    return (
        <>
            <div className="register_user"><a href="#contact">{newUser}</a> </div>
        </>
    )
}
